import React from 'react'
import { Router } from './router'
import './app.css'
import './tailwind.css'
import './markdown.css'

export const App = () => <Router />
